/**
 * Created by zad on 17/12/4.
 */
import confirm from './ModalConfirm';

export default function (content, options) {
  return confirm(content, Object.assign({}, options, { showCancelBtn: false }));
}



// WEBPACK FOOTER //
// ./src/components/Modal/ModalAlert.js